// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__36_hc","buttons":"SendReceipts_buttons__2W8WI","email":"SendReceipts_email__13BPY","bookApptTitle":"SendReceipts_bookApptTitle__xXK4V"};